module.exports = __webpack_public_path__ + "main/assets/public/favicon/favicon-192.ddf44e55de742d5a.png";